import { Component, OnInit } from '@angular/core';
import { MyDocApprovalsConstants } from './constants/my-doc-approvals.constants';
import { MyDocApprovalsService } from './services/my-doc-approvals.service';
import { DocumentLibraryConstants } from '../document/document-library-constants';
import { DocumentSearchResult } from '../document/models/documentSearchResult';
import { LabelConstants } from '../shared/constants/label-constants';

@Component({
  selector: 'app-my-doc-approvals',
  templateUrl: './my-doc-approvals.component.html',
  styleUrls: ['./my-doc-approvals.component.scss']
})
export class MyDocApprovalsComponent implements OnInit{
  topBarTitle:string = MyDocApprovalsConstants.MyDocApprovals_TopBarTitle;
  showAllLabel:string=MyDocApprovalsConstants.MyDocApprovals_ShowAllLabel;
  isIncludeAll = MyDocApprovalsConstants.MyDocApprovals_IsIncludeAll;
  showInformationIconCheckbox = MyDocApprovalsConstants.MyDocApprovals_ShowInformationIconCheckbox;
  inactiveTooltip:string = MyDocApprovalsConstants.MyDocApprovals_CheckBoxHoverToolTip;
  documentSearchResult:DocumentSearchResult[] = [];
  panelListType:string = DocumentLibraryConstants.DocApprovals_PanelListType;
  showLoader : boolean = true;
  isScreenAccessible : boolean = true;
  errorMessage !: string;

  constructor(private myDocApprovalsService:MyDocApprovalsService){ 
  }


  ngOnInit(): void {
    this.getPanelListData(this.isIncludeAll);
  }
  
    includeInactive(isIncludeAll: boolean) {
        this.showLoader = true;
    this.getPanelListData(isIncludeAll);
  }

  getPanelListData(isIncludeAll : boolean){
      this.myDocApprovalsService.getMyDocApprovals(isIncludeAll).subscribe({
          error: (err) => {
              if (err.status === LabelConstants.Forbidden_StatusCode) {
                  this.errorMessage = err.error.detail;
              }
              this.isScreenAccessible = false
          },
          next: (serviceData) => {
              this.documentSearchResult = serviceData,
                  this.showLoader = false;
          }
    });
  }
}
